import { useState, useEffect, useCallback } from 'react';
import { getInsuranceBillingStatus } from 'api/insuranceBilling';
import { TInsuranceBillingStatus } from 'types/insuranceBilling';

let globalData: TInsuranceBillingStatus | null = null;
let globalLoaded = false;

// overrideProviderId：以指定 provider 口径查询（eligibility practice 视图按被查 provider 判 persona）。
// override 结果按 provider 各异，不进全局缓存；换 provider（依赖变化）自动重查
const useInsuranceBillingStatus = (
    overrideProviderId?: number,
): [TInsuranceBillingStatus | null, boolean, () => void] => {
    const override = overrideProviderId != null;
    const [data, setData] = useState<TInsuranceBillingStatus | null>(override ? null : globalData);
    const [loading, setLoading] = useState(override ? true : !globalLoaded);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const res = await getInsuranceBillingStatus(overrideProviderId);
            if (res && !res.error) {
                const result = res.data?.data || null;
                if (!override) {
                    globalData = result;
                    globalLoaded = true;
                }
                setData(result);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [override, overrideProviderId]);

    useEffect(() => {
        if (override || !globalLoaded) {
            fetchData();
        }
    }, [override, fetchData]);

    return [data, loading, fetchData];
};

export default useInsuranceBillingStatus;
